export const searchTerms = [
  'resource',
  'form',
  'user task',
  'human'
].join(' ');
